module.exports = __webpack_public_path__ + "img/landing_code_tt.bd526aad.png";